module.exports = __webpack_public_path__ + "static/dahler-logo.1d5befc7.svg";